import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

const KEY = ['settings', 'users'];

export function useUsers(params = {}) {
  return useQuery({
    queryKey: [...KEY, params],
    queryFn: async () => {
      const { data } = await api.get('/users', { params });
      return data?.users || data?.data || data || [];
    },
    staleTime: 30_000
  });
}

export { KEY as USERS_KEY };
